import { render } from "./FacetItem.vue?vue&type=template&id=120a5cc8&scoped=true"
import script from "./FacetItem.vue?vue&type=script&lang=js"
export * from "./FacetItem.vue?vue&type=script&lang=js"

import "./FacetItem.vue?vue&type=style&index=0&id=120a5cc8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120a5cc8"]])

export default __exports__